import { Injectable, signal, computed } from '@angular/core';
import { FabricVariationModel } from '../models/fabric-variation.model';

const MAX_COMPARISON_ITEMS = 4;

@Injectable({
  providedIn: 'root',
})
export class FabricComparisonService {
  private readonly _fabrics = signal<FabricVariationModel[]>([]);

  readonly fabrics = this._fabrics.asReadonly();
  readonly count = computed(() => this._fabrics().length);
  readonly isFull = computed(() => this._fabrics().length >= MAX_COMPARISON_ITEMS);

  isSelected(uuid: string): boolean {
    return this._fabrics().some((f) => f.uuid === uuid);
  }

  toggle(fabric: FabricVariationModel): 'added' | 'removed' | 'limit_reached' {
    const current = this._fabrics();
    const exists = current.some((f) => f.uuid === fabric.uuid);

    if (exists) {
      this._fabrics.update((list) => list.filter((f) => f.uuid !== fabric.uuid));
      return 'removed';
    }

    if (current.length >= MAX_COMPARISON_ITEMS) {
      return 'limit_reached';
    }

    this._fabrics.update((list) => [...list, fabric]);
    return 'added';
  }

  remove(uuid: string): void {
    this._fabrics.update((current) => current.filter((f) => f.uuid !== uuid));
  }

  clear(): void {
    this._fabrics.set([]);
  }
}
